module.exports = __webpack_public_path__ + "static/media/worker_event_img.d566f592.jpg";